import { useQuery } from '@tanstack/react-query';
import { apiGetContentGenerationRequestsByProject } from '../api/contentGenApis';
import { ContentGenStatus } from '../api/apiTypes';
import { ContentGenerationRecord } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Generate/types';

interface UseGenerationVersionProps {
  retailerId: number;
  retailerSkus: string[];
}

export const useGenerationVersion = ({ retailerId, retailerSkus }: UseGenerationVersionProps) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['profiles', retailerId, retailerSkus],
    queryFn: () =>
      apiGetContentGenerationRequestsByProject({
        retailerId,
        retailerSkus,
        status: ContentGenStatus as unknown as string[]
      })
  });

  return {
    data: data?.data.records.sort((a, b) => b.version - a.version) as ContentGenerationRecord[],
    isLoading,
    error
  };
};
